/* Package JSON Import will be here */
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { Input, Form, Col, Row, Button, Modal } from "antd";
import { getTranslate } from "react-localize-redux";
import Countdown from 'react-countdown';
/* Package JSON Import will be here */

/* Project Import will be here */
import { ButtonSpinner } from "components/Spinner";
/* Project Import will be here */

const OtpForm = (props) => {
    const [form] = Form.useForm();

    const { sessionOtpVerification, rewardsOrderSummary, translate, orders, appSettings } = useSelector((state) => ({
        sessionOtpVerification: state.sessionOtpVerification,
        orders: state.orders,
        rewardsOrderSummary: state.rewardsOrderSummary,
        appSettings: state.appSettings,
        translate: getTranslate(state.locale)
    }));

    useEffect(() => {
        /* initialize auto read OTP */
        if ('OTPCredential' in window)
            window.addEventListener('DOMContentLoaded', otpListener());
    }, []);

    const otpListener = () => {
        /* Only use the otp auto read logic when the OTP popup is open */
        const input = document.querySelector('input[id="otp-form-input"]');
        if (!input) return;

        const ac = new window.AbortController();
        navigator.credentials.get({
            otp: { transport: ['sms'] },
            signal: ac.signal
        }).then(otp => {
            const formInputAvailable = document.querySelector('input[id="otp-form-input"]');
            if (formInputAvailable) {
                /* Assign value to form */
                form.setFieldsValue({ loginOtpInput: otp.code });

                /* Submit the OTP form automatically */
                document.getElementById('otp_from_submit').click();

                /* Abort the signal after successful otp submission */
                ac.abort();
            }
        }).catch(err => {
            console.log(err);
        });
    }

    const resendOtp = () => {
        /* initialize auto read OTP */
        if ('OTPCredential' in window)
            window.addEventListener('DOMContentLoaded', otpListener());

        form.resetFields();
        props.onResendOtp();
    }

    const onFormValueChange = (changedValues, allValues) => {
        allValues.loginOtpInput = changedValues.loginOtpInput.replace(/\D/g, "");
    }

    /* Renderer callback with condition */
    const rendererCounterClock = (counterObj) => {
        if (counterObj.completed) {
            /* Render a completed state */
            return (
                <div className="text-center">
                    <Button type="link" onClick={resendOtp}>
                        {translate("common.buttons.resendOtp")}
                    </Button>
                </div>
            );
        }
        else {
            /* Render a countdown */
            return (
                <div className="text-center font-12">
                    {translate("session.phoneNumberVerification.otpCounterMsg", { time: `${counterObj.formatted.minutes}:${counterObj.formatted.seconds}` })}
                </div>
            );
        }
    };

    return (
        <Modal
            keyboard={true}
            title={translate("common.buttons.otp")}
            footer={null}
            onCancel={props.modalToggle}
            width={500}
            centered
            closeIcon={<i className="fa fa-times-circle fa-lg modal-close-button-icon" aria-hidden="true"></i>}
            visible={props.modalShow}
            maskClosable={false}
        >
            <p className="p-1">{translate("common.pleaseEnterOtp")}</p>

            <Form
                name="addOrEditAddressForm"
                onFinish={props.onSubmit}
                initialValues={{}}
                form={form}
                onValuesChange={onFormValueChange}
            >
                <Row justify="center">
                    <Col span={14}>
                        <Form.Item
                            name="loginOtpInput"
                            rules={[{
                                required: true,
                                pattern: /^(\+\d{0,9}[- ]?)?\d{4}$/,
                                message: translate("common.formValidation.enterValidOtp")
                            }]}
                        >
                            <Input
                                inputMode="numeric"
                                maxLength={4}
                                className="round-radius text-center"
                                placeholder={translate("session.phoneNumberVerification.enterOTP")}
                                autoComplete="off"
                                id="otp-form-input"
                            />
                        </Form.Item>
                    </Col>
                </Row>

                {/* OTP resend counter and resend button */}
                {(!sessionOtpVerification.isLoading && !orders.confirmModal.isLoading && !rewardsOrderSummary.otp.isLoading && appSettings.isEnableResendOtp) &&
                    <div className="pt-1 pb-2">
                        <Countdown
                            date={Date.now() + window.resendOtpTimeInMilliSecond}
                            renderer={rendererCounterClock}
                        />
                    </div>
                }

                <Row justify="center">
                    <Col span={8}>
                        <Form.Item>
                            <Button
                                disabled={sessionOtpVerification.isLoading || orders.confirmModal.isLoading || rewardsOrderSummary.otp.isLoading}
                                type="primary"
                                shape="round"
                                htmlType="submit"
                                block
                                id="otp_from_submit"
                                size="large"
                            >
                                {translate("common.buttons.submit")}
                                {(sessionOtpVerification.isLoading || orders.confirmModal.isLoading || rewardsOrderSummary.otp.isLoading) && <ButtonSpinner />}
                            </Button>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Modal>
    );
};

export default OtpForm;